const cookeiOperations = {
    /**
   * 设置cookie
   * */
    setCookie( name, value, ext ) {
        var Days = 30
        var exp = new Date(),
            expTime,
            cookieStr
        // 过期时间毫秒，否者默认30天
        if ( ext && ext.expires ) {
            expTime = ext.expires
        } else {
            expTime = Days * 24 * 60 * 60 * 1000
        }
        exp.setTime( exp.getTime() + expTime )
        cookieStr = name + `=` + escape( value ) + `;expires=` + exp.toGMTString()
        if ( exp.path ) {
            cookieStr = cookieStr + `;path=` + exp.path
        }
        document.cookie = cookieStr
    },

    /**
   * 读取cookies
   * */
    getCookie( name ) {
        var reg = new RegExp( `(^| )` + name + `=([^;]*)(;|$)` )
        let arr = document.cookie.match( reg )

        if ( arr ) return unescape( arr[ 2 ] )
        else return null
    },

    /**
   * 删除cookies
   * */
    delCookie( name ) {
        var exp = new Date()
        exp.setTime( exp.getTime() - 1 )
        document.cookie = name + `=` + `` + `;expires=` + exp.toGMTString()
    },

    /**
   * session级cookie
   */
    setSessionCookie( name, value ) {
        document.cookie = name + `=` + escape( value ) + `;path=/`
    },

    /**
   * 清空redpoint相关的cookie
   */
    clearRedCookie( _key ) {
    // eslint-disable-next-line no-useless-escape
        let keys = document.cookie.match( /[^ =;]+(?=\=)/g )
        keys.forEach( key => {
            // 限制条件aq_开头，包含_red的cookie
            if ( key.indexOf( `aq_red_` ) === 0 && key.indexOf( _key ) > 0 ) {
                document.cookie = key + `=0;expires=` + new Date( 0 ).toUTCString()
            }
        } )
    },

    /**
   * 拼接红点cookie名
   */
    getRedCookieName( id, page, key ) {
        let arr = [ `aq_red_`, id, `_`, key, `_`, page ]
        return arr.join( `` )
    },

    /**
   * 清理红点session级cookie
   */
    clearRedCookieAll() {
        let arr = [ `_index`, `_safeMobile` ]
        arr.forEach( item => {
            this.clearRedCookie( item )
        } )
    }
}

module.exports = cookeiOperations



// WEBPACK FOOTER //
// ./src/util/cookie.js